module.exports = __webpack_public_path__ + "img/loveman.1630993415105.png";